import { hasAnalyticsConsent } from '../utils/cookieConsent'

const GA_MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID

let initialized = false

const isLocalHost = () =>
  ['localhost', '127.0.0.1', '::1'].includes(window.location.hostname)

// REACT_APP_GA_DEBUG=true is the explicit opt-in for testing against GA4
// DebugView from a local/dev build — see isAnalyticsEnabled below.
const isDebugMode = () => process.env.REACT_APP_GA_DEBUG === 'true'

// Mirrors posthog.js's isAnalyticsEnabled gate (same consent flag, same
// "disabled" console message pattern), plus a hard block on localhost/dev
// builds so analytics never fires from `npm start` or a locally-served
// build unless explicitly overridden for DebugView testing.
const isAnalyticsEnabled = () =>
  !!GA_MEASUREMENT_ID &&
  hasAnalyticsConsent() &&
  (isDebugMode() || (process.env.NODE_ENV === 'production' && !isLocalHost()))

export const initGA4 = () => {
  if (initialized) return
  if (!isAnalyticsEnabled()) {
    console.log('GA4 is disabled')
    return
  }
  initialized = true

  window.dataLayer = window.dataLayer || []
  function gtag() { window.dataLayer.push(arguments) }
  window.gtag = gtag

  const script = document.createElement('script')
  script.async = true
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
  document.head.appendChild(script)

  gtag('js', new Date())
  // send_page_view: false — every page_view (including the first) is sent
  // manually via trackPageView below, from the router location effect in
  // AppContent. gtag's own automatic pageview only fires once on initial
  // script load and has no idea about client-side route changes, so relying
  // on it would both miss SPA navigations and double-count the first page.
  gtag('config', GA_MEASUREMENT_ID, {
    send_page_view: false,
    ...(isDebugMode() ? { debug_mode: true } : {}),
  })
}

// Single call site for every page_view — same "gate lives in one place"
// reasoning as posthog.js's safePosthog wrapper.
export const trackPageView = (path, title = document.title) => {
  if (!isAnalyticsEnabled() || typeof window.gtag !== 'function') return
  window.gtag('event', 'page_view', {
    page_path: path,
    page_location: window.location.href,
    page_title: title,
    // debug_mode set on the config call alone isn't reliably picked up by
    // every subsequent event in practice — setting it explicitly per event
    // is the documented, reliable way to get a hit to show up in DebugView.
    // isDebugMode() is false in production, so normal traffic never carries this.
    ...(isDebugMode() ? { debug_mode: true } : {}),
  })
}
